<template>
  <div class="demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <Tree :data="areaList" :load-data="loadData" @on-select-change="onSelectChange" @on-toggle-expand="onToggleExpand"
          expand-node></Tree>
      </div>
      <div slot="right" class="demo-split-pane">
        <div class="btn-view">
          <Button type="primary" icon="md-add" @click="handleArea('add')">{{ $t('area.index.548708-0') }}</Button>
        </div>
        <VTabel :height="height" :columns="columns" :data="dataList"></VTabel>
      </div>
    </Split>
    <add-model ref="addModel" :show.sync="add.show" v-bind="add" @on-area="area.show = true"
      @on-change="refreshChange"></add-model>
    <select-area :show.sync="area.show" @on-change="onChange"></select-area>
  </div>
</template>

<script>
import VTabel from "@/components/components/VTable/index.vue";
import defaultData from './columns.js'
import AddModel from './add/index.vue'
import SelectArea from './mods/selectArea.vue'
import api from "../../../../api/request.js";
import Cookies from "js-cookie";

const URL = {
  GetCommunitylist: "api/User/GetCommunitylist", // 城市列表
  DeleteRoshCommunity: 'api/User/DeleteRoshCommunity', // 删除城市
  GetVillagelist: "api/User/GetVillagelist", // 区域列表
  DeleteRoshVillage: 'api/User/DeleteRoshVillage', // 删除区域
  GetSVillageList: "api/User/GetSVillageList", // 乡镇列表
  DeleteRoshSVillage: 'api/User/DeleteRoshSVillage', // 删除乡镇
  GetZVillageList: 'api/User/GetZVillageList', // 村列表
  DeleteRoshZVillage: 'api/User/DeleteRoshZVillage', // 删除村
};

export default {
  components: {
    VTabel,
    AddModel,
    SelectArea
  },
  data() {
    return {
      height: window.innerHeight - 190,
      split1: 0.2,
      areaList: [{
        title: this.$t('area.index.548708-1'),
        expand: true,
        children: [],
        grade: 0
      }],
      dataList: [],
      add: {
        show: false,
        data: {},
        area: {}
      },
      area: {
        show: false
      },
      areaItem: {},
    };
  },
  computed: {
    columns() {
      return defaultData.columns(this)
    }
  },
  mounted() {
    this.getWindowInfo()
    window.addEventListener('resize', this.getWindowInfo)
    // 加载城市列表
    this.GetRoshCommunityList()
    this.GetRoshCommunityList('table')
  },
  methods: {
    getWindowInfo() {
      this.height = window.innerHeight - 190;
    },
    handleArea(type, row = {}) {
      switch (type) {
        case 'add':
          this.add.show = true
          this.add.data = {
            type,
          };
          this.$refs.addModel.setArea(this.areaItem)
          break;
        case 'edit':
          this.add.show = true
          this.add.data = {
            type,
            row
          };
          break;

        default:
          break;
      }
    },
    // 选择区域回调
    onChange(item) {
      this.add.area = item
    },

    // 保存刷新
    refreshChange(item) {
      this.GetRoshCommunityList()
      switch (item.grade) {
        case 1:
          this.GetRoshCommunityList('table')
          break;
        case 2:
          this.GetVillagelist(item)
          break;
        case 3:
          this.GetSVillageList(item)
          break;
        case 4:
          this.GetZVillageList(item)
          break;
        default:
          break;
      }
    },

    // 加载城市列表
    GetRoshCommunityList(type = '') {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetCommunitylist}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          // 表格展示
          if (type === 'table') {
            this.dataList = (res.Data || []).map(item => {
              return {
                Name: item.Cname,
                Code: item.Ccode,
                grade: 1,
                ...item
              };
            });
          } else {
            this.areaList[0].children = (res.Data || []).map(item => {
              return {
                title: item.Cname,
                loading: false,
                children: [],
                grade: 1,
                ...item
              };
            });
          }
        }
      });
    },
    // 区域
    GetVillagelist(item, callback = null) {
      const { Cname } = item
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetVillagelist}?Ccode=${item.Ccode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          if (callback) {
            const data = (res.Data || []).map(item => {
              return {
                title: item.Vname,
                loading: false,
                children: [],
                grade: 2,
                ...item
              };
            });
            if (data.length) {
              callback(data);
            } else {
              callback([{
                title: this.$t('area.index.548708-2'),
                disabled: true
              }]);
            }
          } else {
            this.dataList = (res.Data || []).map(item => {
              return {
                Name: item.Vname,
                Code: item.Vcode,
                Cname,
                grade: 2,
                ...item
              };
            });
          }
        }
      });
    },
    // 乡镇
    GetSVillageList(item, callback = null) {
      const { Vname } = item
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetSVillageList}?Vcode=${item.Vcode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          if (callback) {
            const data = (res.Data || []).map(item => {
              return {
                title: item.Sname,
                // loading: false,
                // children: [],
                grade: 3,
                ...item
              };
            });
            if (data.length) {
              callback(data);
            } else {
              callback([{
                title: this.$t('area.index.548708-2'),
                disabled: true
              }]);
            }
          } else {
            this.dataList = (res.Data || []).map(item => {
              return {
                Name: item.Sname,
                Code: item.Scode,
                Vname,
                grade: 3,
                ...item
              };
            });
          }
        }
      });
    },
    // 村
    GetZVillageList(item, callback = null) {
      const { Sname } = item
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetZVillageList}?Scode=${item.Scode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          if (callback) {
            const data = (res.Data || []).map(item => {
              return {
                title: item.Zname,
                grade: 4,
                ...item
              };
            });
            // callback(data);
          } else {
            this.dataList = (res.Data || []).map(item => {
              return {
                Name: item.Zname,
                Code: item.Zcode,
                Sname,
                grade: 4,
                ...item
              };
            });
          }
        }
      });
    },
    // 加载更多
    loadData(item, callback) {
      switch (item.grade) {
        case 1:
          this.GetVillagelist(item, callback);
          break;
        case 2:
          this.GetSVillageList(item, callback)
          break;
        case 3:
          this.GetZVillageList(item, callback)
          break;
        default:
          break;
      }
    },
    // 点击节点触发
    onSelectChange(list) {
      if (list.length) {
        const [item] = list
        this.areaItem = { ...item }
        const { grade } = item
        switch (grade) {
          case 0:
            this.GetRoshCommunityList('table')
            break;
          case 1:
            this.GetVillagelist(item)
            break;
          case 2:
            this.GetSVillageList(item)
            break;
          case 3:
            this.GetZVillageList(item)
            break;
          default:
            break;
        }
      }
    },
    onToggleExpand(item) {
      this.areaItem = { ...item }
      const { grade } = item
      switch (grade) {
        case 0:
          this.GetRoshCommunityList('table')
          break;
        case 1:
          this.GetVillagelist(item)
          break;
        case 2:
          this.GetSVillageList(item)
          break;
        case 3:
          this.GetZVillageList(item)
          break;
        default:
          break;
      }
    },

    // 编辑回调
    editClick(row) {
      this.handleArea('edit', row)
    },

    // 删除回调
    removeClick(row) {
      let url = ''
      switch (row.grade) {
        case 1:
          url = URL.DeleteRoshCommunity
          break;
        case 2:
          url = URL.DeleteRoshVillage
          break;
        case 3:
          url = URL.DeleteRoshSVillage
          break;
        case 4:
          url = URL.DeleteRoshZVillage
          break;
        default:
          break;
      }
      this.DeleteAsios(row.grade, row, url)
    },

    // 删除城市
    DeleteAsios(grade, row, url) {
      api({
        method: "post",
        url,
        data: { ...row },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          this.$Message['success']({
            background: true,
            content: res.Message
          });
          this.refreshChange(row)
        } else {
          this.$Message['error']({
            background: true,
            content: res.Message
          });
        }
      });
    },

  },
};
</script>

<style scoped>
.demo-split {
  height: 100%;
  border: 1px solid #dcdee2;
}

.demo-split-pane {
  height: 100%;
  padding: 10px 20px;
  overflow-y: auto;
}

.btn-view {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/views/area/index.vue